import { useMutation } from '@tanstack/react-query';
import {
  ConfirmRegistrationError,
  resolveConfirmErrorCode,
} from '../register.utils';
import { confirmRegistration } from '@/services/register.service';
import type { ConfirmUserRegistrationError } from '@/services/register.types';
import { Location } from '@/utils/windowsUtils';

export type ConfirmSubmitValues = {
  confirmationCode: string;
};

interface UseConfirmMutationArgs {
  registrationToken: string;
  onError: (errorCode: ConfirmUserRegistrationError) => void;
}

const useConfirmMutation = ({
  registrationToken,
  onError,
}: UseConfirmMutationArgs) =>
  useMutation({
    mutationFn: async ({ confirmationCode }: ConfirmSubmitValues) => {
      const { data } = await confirmRegistration({
        registrationToken,
        confirmationCode,
      });

      // A confirmation failure is reported in the body of a 2xx response.
      if (data.error) {
        throw new ConfirmRegistrationError(data.error);
      }

      return data;
    },
    onSuccess: ({ redirectUrl }) => {
      if (redirectUrl) {
        Location.change(redirectUrl);
      }
    },
    onError: (error) => onError(resolveConfirmErrorCode(error)),
  });

export default useConfirmMutation;
